import React from 'react';
import useRDFormulaGrid from './hooks/useRDFormulaGrid';
import BaseFormGrid from '../../../../components/grids/BaseFormGrid';
import TranslatableText from '../../../../components/i18n/TranslatableText';
import { RDFormulasGridDefs } from '../../../../constants/i18n/translations/termDefinitions/formulation';

const RDFormulaGrid = () => {
    const {
        isLoadingFormulaList,
        columnDefs,
        redirectToForm,
        onGridReady,
        defaultColumnDefinitionOptions,
        formulaList,
        isLoadingItemMasterOptions,
        isLoadingUserOptions,
        canCreateFormula,
        canViewFormula,
        termSet,
    } = useRDFormulaGrid();

    return (
        <BaseFormGrid
            title={
                <>
                    <TranslatableText
                        termKey={RDFormulasGridDefs.Title}
                        termSet={termSet}
                    />
                </>
            }
            autoSize={true}
            displayGrid={canViewFormula}
            isLoading={
                isLoadingFormulaList ||
                isLoadingItemMasterOptions ||
                isLoadingUserOptions
            }
            rowData={formulaList}
            columnDefs={columnDefs}
            gridClass="full-size-item"
            displayToolbar={true}
            displayCreateNewButton={canCreateFormula}
            displayExportDataButton={false}
            displayResetStateButton={false}
            onCreateNew={redirectToForm}
            onRowClicked={({ data }) => redirectToForm(data)}
            onGridReady={onGridReady}
            defaultColDef={defaultColumnDefinitionOptions}
            sizeColumnsToFit={true}></BaseFormGrid>
    );
};

export default RDFormulaGrid;
